export const nodeEnv = process.env.REACT_APP_NODE_ENV!;
export const isProduction =
  nodeEnv !== 'development' && nodeEnv !== 'development-local';
export const apiBase = {
  'development-local': process.env.REACT_APP_API_BASE_DEV_LOCAL,
  'production-local': process.env.REACT_APP_API_BASE_PROD_LOCAL,
  development: process.env.REACT_APP_API_BASE_DEV,
  production: process.env.REACT_APP_API_BASE_PROD,
}[nodeEnv]!;
export const intercomAppId = process.env.REACT_APP_INTERCOM_APP_ID ?? '';
export const captchaServerKey = process.env.REACT_APP_CAPTCHA_SERVER_KEY ?? '';
export const theGraphBase = process.env.REACT_APP_THE_GRAPH_BASE ?? '';
export const theGraphBaseRinkeby =
  process.env.REACT_APP_THE_GRAPH_BASE_RINKEBY ?? '';
export const theGraphBaseGoerli =
  process.env.REACT_APP_THE_GRAPH_BASE_GOERLI ?? '';
export const theGraphBaseRopsten =
  process.env.REACT_APP_THE_GRAPH_BASE_ROPSTEN ?? '';
export const s3Base = (
  isProduction
    ? process.env.REACT_APP_AWS_S3_BASE_PROD
    : process.env.REACT_APP_AWS_S3_BASE_DEV
)!;
export const bridgeUrl = (
  isProduction
    ? process.env.REACT_APP_BRIDGE_URL_PROD
    : process.env.REACT_APP_BRIDGE_URL_DEV
)!;
export const swapUrl = (
  isProduction
    ? process.env.REACT_APP_SWAP_URL_PROD
    : process.env.REACT_APP_SWAP_URL_DEV
)!;
export const buyUrl = (
  isProduction
    ? process.env.REACT_APP_BUY_URL_PROD
    : process.env.REACT_APP_BUY_URL_DEV
)!;
export const theGraphBaseBinanceTest =
  process.env.REACT_APP_THE_GRAPH_BASE_BINANCE_TEST ?? '';
export const theGraphBaseBinance =
  process.env.REACT_APP_THE_GRAPH_BASE_BINANCE ?? '';

export const moonPayApiKey = process.env.REACT_APP_MOONPAY_API_KEY ?? '';

// <JIM GLUE>
export const theGraphBaseBinanceJim = isProduction
  ? theGraphBaseBinance
  : theGraphBaseBinanceTest;
// export const theGraphBaseBinanceJim = window.location.href.includes(
//   'https://film3.mogulproductions.com/',
// )
//   ? process.env.REACT_APP_THE_GRAPH_BASE_JIM_JONES ??
//     'https://api.thegraph.com/subgraphs/id/QmbnAD6gQDbGa6XkmDGu2vpNZSMB5PLzvqxCr29rpoCXrq'
//   : 'https://api.thegraph.com/subgraphs/name/mogulproductions/mogul-bsc-v2';
// </JIM GLUE>

export const cloudfrontDevBase =
  process.env.REACT_APP_CLOUDFRONT_DEV_BASE ??
  'https://dqw085nogrolf.cloudfront.net';
export const cloudfrontProdBase =
  process.env.REACT_APP_CLOUDFRONT_PROD_BASE ??
  'https://d8r7g9tzupsfa.cloudfront.net';

// Production only when Netlify has production url AND not on master branch :)
export const production =
  window.location.toString().includes('staging--priceless-davinci-c582b6') ||
  window.location.toString().includes('mogulproductions');
export const config = {};
